// 时间格式化
export function formatTime(value) {
    return value < 10 ? "0" + value : value;
  }
  